// import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { Applicazione, apps, AppType } from "../models/applicazione";
import { merge } from "lodash";
import { Principal } from "../models/principal";

export const getFederatedApp = (ip: string, authData: AuthDataType, user: User, identity: Principal) => {
    
    // return fetch(`${this.endpoint}/applicazioni`, this.createJsonFetchOptions('GET'))
    //     .then<Applicazione[]>(this.asJson);

    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Get Agencies body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/federation`
    console.log('getFederatedApp', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
        // body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getFederatedApp ("${authData.user}") -> letti ${json.length} applicaziones`);
            //List sono le app configurate come diritti su Piero
            const list = json as Applicazione[];
            console.log('getFederatedApp recuperate: ' + JSON.stringify(list));
            let items: Applicazione[] = [];
            //apps sono le applicazioni mappate su Piero
            apps.map(app => {
                let item = merge(new Applicazione(), app);
                // item.inactive = list.find(x => x.guid === app.guid) === undefined;
                if (item.Type === AppType.IFORFETTARI && identity && !identity.ApplicationForfetari) 
                    item.inactive = true;
                else if (item.Type === AppType.CONVSRL && identity && !identity.ApplicationConvenienza)
                    item.inactive = true;
                else if (item.Type === AppType.BUDGET4U && identity && !identity.ApplicationBudget)
                    item.inactive = true;
                else if (item.Type === AppType.EASYSTART && identity && !identity.ApplicationEasyStart)
                    item.inactive = true;
                
                items.push(item);
            })
            // console.log('getFederatedApp item creati: ' + JSON.stringify(items));
            return items;
        })
        .catch(error => {
            console.log('getApplicazioni error:', error);
            throw error;
        });

}
